import Swiper from "swiper";

function initNavigationSlider(){
	$('.js-navigation-slider').each(function(index) {
		let $this = $(this);
		//console.log($(this));
		let parentWrapper = $this.parents('.navigation-slider__wrapper');
		parentWrapper.find('.navigation-slider__navigation').addClass('navigation-slider__navigation-' + index);
		parentWrapper.find('.navigation-slider__counter').addClass('navigation-slider__counter-' + index);
		$this.addClass('navigation-slider-' + index);

		let navSliderList = [];
		let $counterContainer = $(`.navigation-slider__counter-${index}`);

		let navSlider = new Swiper('.navigation-slider-' + index, {
			slidesPerView: 1,
			speed: 400,
			spaceBetween: 10,
			centeredSlides: false,
			loop: false,
			simulateTouch: true,
			observer: true,
			observeParents: true,

			navigation:  {
				nextEl: `.navigation-slider__navigation-${index} .swiper-button-next`,
				prevEl: `.navigation-slider__navigation-${index} .swiper-button-prev`
			},

			on: {
				init: function (swiper) {
					$counterContainer.text(`${swiper.activeIndex + 1}/${swiper.slides.length}`)
				},
				slideChange: function (swiper) {
					$counterContainer.text(`${swiper.activeIndex + 1}/${swiper.slides.length}`);
				}
			}
		});

		navSliderList.push(navSlider);
		navSlider.init();
	});
}

export function init() {
	initNavigationSlider();
}
